<template>
    <div class="table-box">
      <h2 style="float: left;">平台资料上传列表</h2>
<!--      <el-button style="float: right;"  size="mini" type="success" @click="selectScoreItem()">上传文档</el-button >-->
      <el-table
        :data="itemlist"
        height="550"
        border
        style="width: 100%;">

        <el-table-column
          prop="scoreTypeName"
          label="指标类别"
          width="180">
        </el-table-column>
        <el-table-column

          label="指标项与分值">
          <template slot-scope="scope">
            {{scope.row.scoreItem}}(分值：{{scope.row.scoreValue}}分)
          </template>
        </el-table-column>
        <el-table-column

          label="考核资料">
          <template slot-scope="scope">
            <el-link  type="primary" :href="scope.row.fileUrl" target="_blank">{{scope.row.fileName}}</el-link>
          </template>

        </el-table-column>
        <el-table-column

          label="操作">
          <template slot-scope="scope">
            <el-button

              size="mini"
              type="danger"
              @click="deleteScoreItem(scope.row.scoreItemFileId)">删除</el-button>
          </template>

        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="itemspageSize"
        @current-change="setScoreItemr"
        :total="itemstotal">

      </el-pagination>

      <el-dialog class="table-box" style="background: none;" :modal="true" width="800px" :visible.sync="TableVisible">
        <el-table
          :data="ScoreItemlist"
          height="474"
          border
          style="width: 100%;">
          <el-table-column
            prop="scoreItemId"
            label="序号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="scoreTypeName"
            label="指标类别"
            width="180">
          </el-table-column>
          <el-table-column
            label="指标项与分值"
            width="160">
            <template slot-scope="scope">
              {{scope.row.scoreItem}}(分值：{{scope.row.scoreValue}}分)
            </template>
          </el-table-column>
          <el-table-column

            label="功能">

            <template slot-scope="scope">
              <el-upload
                style="    border: 0px dashed #d9d9d9; float: none;"
                :data="{id:scope.row.scoreItemId}"
                :action="afileUrl"
                :show-file-list="true"
                :on-success="onsuccess"
                :file-list="fileList">

                <el-button

                  size="mini"
                  type="success"
                  @click="upload(scope.row.scoreItemId)"
                >上传</el-button>
              </el-upload>

            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="ScoreItempageSize"
          @current-change="ScoreItem"
          :total="ScoreItemtotal">
        </el-pagination>
      </el-dialog>

    </div>

</template>

<script>
export default {
  name: "Upload",
  data(){
    return{
      itemspage:1,
      itemstotal:0,
      itemlist:[],
      itemspageSize:10,
      TableVisible:false,


      //上传资料详情
      ScoreItempage:1,
      ScoreItemtotal:0,
      ScoreItemlist:[],
      ScoreItempageSize:10,

      afileUrl:'/webapi/upload/oneDoc',
      fileList:[],



    }
  },
  props:["curId",'year','quarter'],
  watch:{
    curId:function(value){
      //this.selecTopera();
    },

  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{
     // vm.getGradeDet();
    });
  },
  mounted () {
    window.setTimeout(() => {
      this.selectScoreItemr();
    }, 200);
  },
  methods:{
    //获取上传项列表
    selectScoreItemr(){
      let that = this;
      if(this.curId == '' || this.curId == null){
        that.$message.error("登录超时");
        that.$router.push({name:'Login'})
      }
      let score ={
        page:this.itemspage,
        pageSize:10,
        operatorNum:Number(this.curId),
        year:Number(this.year),
        quarter:Number(this.quarter),
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/webapi/scoreItemFile/selectScoreFile',score)
        .then(function (res) {
          that.itemstotal = res.data.data.total;
          that.itemlist = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setScoreItemr(itemspage){
      this.itemspage = itemspage;
      this.selectScoreItemr(this.curId);
    },
    deleteScoreItem(scoreId){
      let that = this;
      let scoreIds = {
        scoreItemFileIds:[]
      }
      scoreIds.scoreItemFileIds.push(scoreId);
      this.$axios
        .post('/webapi/scoreItemFile/batchDeleteScoreFile',scoreIds)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    selectScoreItem(){
      this.TableVisible = true
      var that = this;
      var ScoreItem ={
        page:this.ScoreItempage,
        pageSize:this.ScoreItempageSize,
        needFile:1,
      }

      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/webapi/scoreItem/selectScoreItem',ScoreItem)
        .then(function (res) {

          that.ScoreItemtotal = res.data.data.total;
          that.ScoreItemlist = res.data.data.list;

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    ScoreItem(ScoreItempages){
      this.ScoreItempage = ScoreItempages;
      this.selectScoreItem(this.curId);
    },

    upload(scoreItemId){
      this.noneUploadImg = scoreItemId;
    },

    onsuccess(res, file, fileList){
      var that = this;
      if(res.code==200){
        that.scoreItemUrl = res.data.url;
        that.fileName = res.data.fileName;
        that.uploadScoreFile(that.noneUploadImg);
        that.noneUploadImg = '';
      }else{
        that.$message.error('上传失败');
      }
    },


    uploadScoreFile(id){
      var that = this;
      if(this.curId == '' || this.curId == null){
        that.$message.error("登录超时");
        that.$router.push({name:'Login'})
      }
      var score ={
        operatorNum:this.curId,
        scoreItemId:id,
        scoreItemUrl:this.scoreItemUrl,
        fileName:this.fileName
      }
      that.$axios.defaults.withCredentials=true;
      that.$axios
        .post('/webapi/scoreItemFile/uploadScoreFile',score)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '保存成功',
              type: 'success'
            });

            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }else{
            that.$message.error(
              '保存失败'
            );
          }
          // console.log(res);
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },

  },


}
</script>
<style >

</style>
<style scoped>
.el-upload {
  border: 0px dashed #d9d9d9;
   float: none;
}
.el-button--mini, .el-button--mini.is-round {
padding: 11px 19px;
font-size: 16px;
margin-right: 20px;
margin: 16px;
}
.uploadIcon {
display: block !important; /* 上传按钮隐藏 */
}
html,body,#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.el-message-box{
  width: 800px;
}
.el-table__header{
  width: 100%!important;
}
#app {

  background: rgba(0,0, 0, 0.05);
}
.el-container{
  height: 100%;
}
.el-menu{
  background: none;
  margin-top: 50px;
  border: 0px;
}
.el-menu-item{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 25px auto;
  height: 78px;
}
.el-menu-item:hover{
  background: #7073FF;
}
.el-menu-item.is-active {
  color: #fff;
  background: #7073FF;
}
.el-menu-item [class^=el-icon-] {
  margin-right: 0px;
  width: 34px;
  text-align: center;
  font-size: 34px;
  vertical-align: middle;
  margin-left: 0px;
}
.el-menu-item i {
  color: #fff;
}
.el-menu-item p{
  line-height: 4px;
  margin: 0px;

}
.el-header, .el-footer {
  width: 100%;
  height: 88px;
  background: #FFFFFF;
  box-shadow: -10px 10px 20px 0px rgba(30, 30, 30, 0.05);
  margin: 30px auto;
  padding: 0 60px;
}
.el-header h1{
  line-height:60px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #222222;
  float: left;
  margin: 0;
}
.el-header span{
  float: right;
  line-height: 60px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
}
.el-main {
  width: 100%;
  background-color: #fff;
  color: #333;
  text-align: center;
  padding: 0;

}
.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
  border-color: #EDEFF5;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #EDEFF5;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #109585;
color: #fff;
}
.el-pagination.is-background .el-pager li:hover{
  color: #fff!important;
  background-color: #109585 !important;

}
.table-box {
  width:95%;
  padding: 30px;
  background: #FFFFFF;

}
.el-table th > .cell {
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000000;


}

.el-table .cell {
  text-align: center;

}
.el-table thead tr{
  background: none;

  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
}
.el-avatar{
  margin-top:54px;
  width: 64px;
  height: 64px;
  border: 2px solid #FFFFFF;
  border-radius: 50%;

}
.el-aside {
  background-color: #3E4356;
  color: #FFFFFF;
  text-align: center;
  box-shadow: 3px 0px 8px 0px rgba(62, 67, 86, 0.26);
}

.el-table .el-button--success{

  background: #109585;
  border-radius: 4px;
  border-color: #109585;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 100%;
}
.el-pagination{
  padding: 16px 5px;
}
.el-menu-item{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 25px auto;
  height: 78px;
  padding-right: 8px!important;
  padding-left: 8px!important;
  padding-bottom: 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/view/Uploadlist.vue